// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-products-mobile[data-v-932f1ffe]{display:flex;flex-wrap:wrap;margin-top:-20px;margin-left:-20px}.content-products-mobile>*[data-v-932f1ffe]{width:calc(50% - 20px);margin-top:20px;margin-left:20px}@media(max-width:639px){.content-products-mobile>*[data-v-932f1ffe]{width:calc(100% - 20px)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
